/**
 * Updates the rep assignment.
 *
 * @param newRepId A string representing the ID of the new representative to assign.
 * @returns A promise that resolves to the response data if the update is successful.
 * @throws An error if the fetch request fails, the response is not OK, or an unexpected error occurs.
 */
export const updateRep = async (newRepId: string) => {
  try {
    const response = await fetch('/rep/ajax/save', {
      method: 'POST',
      body: `rep_id=${newRepId}`,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating rep:', error);
    throw error;
  }
};
